/**
 * Border radius tokens
 *
 * @module @smoothie-framework/ui-core/tokens
 */
export const RADIUS_ALIAS_REFERENCES = Object.freeze({
    l1: '{radii.xs}',
    l2: '{radii.sm}',
    l3: '{radii.md}',
});
export const radii = {
    none: 0,
    '2xs': 1,
    xs: 2,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 12,
    '2xl': 16,
    '3xl': 24,
    '4xl': 32,
    full: 9999,
};
const RADIUS_TOKEN_SET = new Set([
    ...Object.keys(radii),
    ...Object.keys(RADIUS_ALIAS_REFERENCES),
]);
export function isRadiusToken(value) {
    return RADIUS_TOKEN_SET.has(value);
}
export const RADIUS_TOKEN_KEYS = Object.freeze(Array.from(RADIUS_TOKEN_SET).sort());
//# sourceMappingURL=radii.js.map